import { connect } from 'react-redux'

import filterAirportOptions from '../../utils/airports/filterAirportOptions'

import HTMLAutocomplete from '../../components/HTMLAutocomplete'

export const mapStateToProps = state => {
  const airports = state.v1airports.items.map(airport => {
    const { id, name } = airport
    return { id, name: `${id} - ${name}` }
  })

  return {
    options: airports,
  }
}

export const mapDispatchToProps = () => ({
  filterMethod: filterAirportOptions,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HTMLAutocomplete)
